import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./Auth.css";

export default function SignIn() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { signin, branding } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await signin(form.email, form.password);
      navigate(data.isConfigured ? "/app/phone" : "/setup");
    } catch (err) {
      setError(err.response?.data?.error || "Invalid credentials");
    }
    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          {branding?.logo_full
            ? <img src={branding.logo_full} alt="Logo" style={{maxHeight:60,maxWidth:200,objectFit:"contain"}}/>
            : <><div className="auth-logo-mark">L</div><div className="auth-logo-text"><span className="auth-brand">Leovoid</span><span className="auth-product">UCaaS</span></div></>
          }
        </div>

        <h1 className="auth-title">Welcome back.</h1>
        <p className="auth-subtitle">Sign in to your workspace.</p>

        {error && <div className="msg-error" style={{ marginBottom: 16 }}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="label">Email</label>
            <input
              type="email"
              value={form.email}
              onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
              placeholder="you@company.com"
              required
              autoFocus
            />
          </div>
          <div className="form-group">
            <label className="label">Password</label>
            <input
              type="password"
              value={form.password}
              onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
              placeholder="••••••••"
              required
            />
          </div>
          <button type="submit" className="btn btn-primary auth-btn" disabled={loading}>
            {loading ? <span className="spinner" /> : "Sign In"}
          </button>
        </form>

        <p className="auth-switch">
          Don't have an account? <Link to="/signup">Create one</Link>
        </p>
      </div>
    </div>
  );
}
